const MAX_COUNT_OF_PROMPT_IMPRESSIONS = 5;
const COUNT_OF_PROMPT_IMPRESSIONS_KEY = 'count_of_prompt_impressions';
const IS_PROMPT_SHOW_KEY = 'is_prompt_show';

export const showInstallPrompt = (onComplete?: () => void) => {
  if (window.deferredPrompt) {
    window.deferredPrompt
      .prompt()
      .then(() => {
        window.deferredPrompt?.userChoice.then((answer) => {
          if (answer.outcome === 'accepted') {
            window.deferredPrompt = null;
          }
        });
      })
      .catch((error) => console.error(`Failed to execute 'showInstallPrompt': ${error?.message}`))
      .finally(onComplete);
  }
};

export const showInstallMobilePrompt = () => {
  const countOfPromptImpressions = Number(localStorage.getItem(COUNT_OF_PROMPT_IMPRESSIONS_KEY) || 0);
  const isPromptShow = Boolean(sessionStorage.getItem(IS_PROMPT_SHOW_KEY));

  if (countOfPromptImpressions < MAX_COUNT_OF_PROMPT_IMPRESSIONS || !isPromptShow) {
    showInstallPrompt(() => {
      localStorage.setItem(COUNT_OF_PROMPT_IMPRESSIONS_KEY, String(countOfPromptImpressions + 1));
      sessionStorage.setItem(IS_PROMPT_SHOW_KEY, 'true');
    });
  }
};
